"use client"

import { useState } from "react"
import SignupModal, { SIGNUP_MODAL_ENABLED } from "./SignupModal"
import LoginModal from "./LoginModal"

export default function SignupButton({ text, forceModal }: { text: string; forceModal?: boolean }) {
    const [isSignupOpen, setIsSignupOpen] = useState(false)
    const [isLoginOpen, setIsLoginOpen] = useState(false)

    const enabled = forceModal || SIGNUP_MODAL_ENABLED

    if (!enabled) {
        return (
            <a className="btn-sm text-slate-300 hover:text-white transition duration-150 ease-in-out w-full group [background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none" href="/signup">
                <span className="relative inline-flex items-center">
                    {text} <span className="tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
                </span>
            </a>
        )
    }

    return (
        <>
            <button
                onClick={() => setIsSignupOpen(true)}
                className="btn-sm text-slate-300 hover:text-white transition duration-150 ease-in-out w-full group [background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none"
            >
                <span className="relative inline-flex items-center">
                    {text} <span className="tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
                </span>
            </button>
            <SignupModal
                isOpen={isSignupOpen}
                onClose={() => setIsSignupOpen(false)}
                onSwitchToLogin={() => { setIsSignupOpen(false); setIsLoginOpen(true) }}
            />
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setIsLoginOpen(false)}
                onSwitchToSignup={() => { setIsLoginOpen(false); setIsSignupOpen(true) }}
            />
        </>
    )
}
